module.exports = __webpack_public_path__ + "static/media/foot-logo.3793d917.png";